import { SearchModel, SubscriptionTier } from '#pplx/frontend/ask-models/types/search-modes.js';
/**
 * Specifies the schema version this module adhears to
 */
export const CONFIG_SCHEMA_VERSION = 'v1';
/**
 * This default data serves two purposes
 * 1. Instantly populate at least one model
 * 2. Provides a fallback in case the BE errors out or cannot be reached
 */
export const MODEL_CONFIG_DEFAULT_DATA = {
    config_schema: CONFIG_SCHEMA_VERSION,
    computer_harness: {
        default_mode: 'standard',
        modes: {},
    },
    models: {
        [SearchModel.SONAR]: {
            label: 'Sonar',
            description: "Perplexity's latest model",
            mode: 'search',
            provider: 'PERPLEXITY',
        },
        [SearchModel.GPT_5_5]: {
            label: 'GPT-5.5',
            description: "OpenAI's latest model",
            mode: 'search',
            provider: 'OPENAI',
        },
        [SearchModel.BROWSER_AGENT_SONNET]: {
            label: 'Claude Sonnet 5',
            description: "Anthropic's fast model",
            mode: 'browser_agent',
            provider: 'ANTHROPIC',
        },
        [SearchModel.BROWSER_AGENT_OPUS]: {
            label: 'Claude Opus 4.8',
            description: "Anthropic's most advanced model",
            mode: 'browser_agent',
            provider: 'ANTHROPIC',
        },
        [SearchModel.ASI]: {
            label: 'Agent',
            description: 'Agent',
            mode: 'asi',
            provider: 'ANTHROPIC',
        },
    },
    agentic_research_compare_models: [
        SearchModel.GPT_5_4_THINKING,
        SearchModel.CLAUDE_4_6_OPUS_THINKING,
        SearchModel.GEMINI_3_1_PRO,
    ],
    config: [
        {
            label: 'Sonar',
            description: "Perplexity's fast model",
            non_reasoning_model: SearchModel.SONAR,
            reasoning_model: null,
            has_new_tag: false,
            subscription_tier: SubscriptionTier.PRO,
            text_only_model: false,
            is_default: false,
        },
        {
            label: 'Claude Sonnet 5',
            description: "Anthropic's fast model",
            non_reasoning_model: SearchModel.BROWSER_AGENT_SONNET,
            reasoning_model: null,
            has_new_tag: false,
            subscription_tier: SubscriptionTier.PRO,
            text_only_model: false,
            is_default: false,
        },
        {
            label: 'Claude Opus 4.8',
            description: "Anthropic's most advanced model",
            non_reasoning_model: SearchModel.BROWSER_AGENT_OPUS,
            reasoning_model: null,
            has_new_tag: false,
            subscription_tier: SubscriptionTier.MAX,
            text_only_model: false,
            is_default: false,
        },
    ],
    default_models: {
        search: 'turbo',
        research: 'pplx_alpha',
        study: 'pplx_study',
        agentic_research: 'pplx_agentic_research',
        browser_agent: SearchModel.BROWSER_AGENT_SONNET,
        asi: 'pplx_asi',
    },
};
//# sourceMappingURL=consts.js.map